import axios from "axios";

axios.interceptors.response.use(
  async (response) => {
    const responseURL = response?.request?.responseURL;

    if (responseURL === "https://usgaghin.statuspage.io/") {
      try {
        window.location.href = "https://usgaghin.statuspage.io/";
      } catch (error) {
        console.error("Error during redirect call:", error);
      }
    }
    return response;
  },

  (error) => {
    console.error("Axios error:", error);
    return Promise.reject(error);
  }
);
